<template>
  <div class="restaurant">
    <div class="smartphone-titles" v-if="isSmartphone">
      <h3>{{ restaurant.title.rendered }}</h3>
      <h4 v-if="restaurant.acf.subtitle">{{ restaurant.acf.subtitle }}</h4>
    </div>
    <div class="photo-column">
      <img :src="restaurant.acf.photo" />
    </div>
    <div class="content-column">
      <template v-if="!isSmartphone">
        <h3>{{ restaurant.title.rendered }}</h3>
        <h4 v-if="restaurant.acf.subtitle">{{ restaurant.acf.subtitle }}</h4>
      </template>
      <div class="properties">
        <div>
          <div class="property">
            <div class="title">Адрес</div>
            <div class="text" v-html="address"></div>
          </div>
          <div class="property">
            <div class="title">Телефон</div>
            <div class="text"><phone :phone="restaurant.acf.phone" /></div>
          </div>
        </div>
        <div>
          <div class="property">
            <div class="title">Метро</div>
            <div class="text" v-html="metro"></div>
          </div>
          <div class="property">
            <div class="title">Часы работы</div>
            <div class="text">{{ restaurant.acf.time }}</div>
          </div>
        </div>
      </div>
      <div class="description">{{ restaurant.acf.description }}</div>
      <div class="actions">
        <div class="menu-button-container" v-if="restaurant.acf.menus.length > 1" >
          <div class="button menu" @click="openMenuPopoverOptions">
            <svg-inline :src="require('@/assets/icons/menu.svg')" />
            <span>Смотреть меню</span>
          </div>
          <div class="menu-popover-options" :class="{ 'shown': menuPopoverOptionsShown }" v-click-outside="hideMenuPopoverOptions">
            <a v-for="(menu, index) in restaurant.acf.menus"
               :key="index"
               target="_blank"
               :href="menu.file"
               @click.force="hideMenuPopoverOptions"
            >{{ menu.title }}</a>
          </div>
        </div>
        <div class="menu-button-container" v-else>
          <a class="button menu" target="_blank" :href="restaurant.acf.menus[0].file">
            <svg-inline :src="require('@/assets/icons/menu.svg')" />
            <span>Смотреть меню</span>
          </a>
        </div>
        <router-link class="red button reserve-table" :to="{ name: 'ReserveTable', params: { restaurant: restaurant.slug } }">Заказать столик</router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import Phone from '/src/components/Phone'

  export default {
    name: 'Restaurant',
    data () {
      return {
        menuPopoverOptionsShown: false
      }
    },
    computed: {
      address () {
        // eslint-disable-next-line no-control-regex
        let res = this.restaurant.acf.address.replace(new RegExp('\r\n', 'g'), '<br/>')
        // if (this.isSmartphone) {
        //   res = res.replace(new RegExp(String.fromCharCode(160), 'g'), ' ')
        // }
        return res
      },
      metro () {
        let res = this.restaurant.acf.metro
        if (this.isSmartphone) {
          res = res.replace(new RegExp(String.fromCharCode(160), 'g'), ' ')
        }
        return res
      }
    },
    components: {
      Phone
    },
    props: {
      restaurant: {
        type: Object,
        required: true
      }
    },
    methods: {
      openMenuPopoverOptions (e) {
        this.menuPopoverOptionsShown = true
        e.stopPropagation()
      },
      hideMenuPopoverOptions () {
        this.menuPopoverOptionsShown = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Restaurant.vue